export const IMAGE_FORMATS_ACCEPTED = ["image/jpeg", "image/png", "image/webp"]
export const IMAGE_MAX_SIZE_IN_KiB = 500
export const IMAGE_MAX_SIZE_IN_kB = 512
export const IMAGE_MAX_WIDTH = 1024
export const IMAGE_MAX_HEIGHT = 1024
